"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var date_fns_1 = require("date-fns");
var React = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var bundle_components_1 = __importDefault(require("../../../bundle-components"));
exports.default = (function (props) {
    var _a, _b;
    var groupedSubscription = props.groupedSubscription;
    var address = groupedSubscription.address, subscription = groupedSubscription.subscription;
    var bundleType = new bundle_components_1.default(groupedSubscription).getBundleType();
    return (React.createElement("div", { className: 'account-card margin-bottom-3' },
        React.createElement("div", { className: 'bg-white', style: { borderRadius: '0 0 5px 5px' } },
            React.createElement(react_router_dom_1.Link, { to: "/subscriptions/edit-items/".concat(subscription.id), className: 'bg-wisteria text-white padding-5 h5 display-block', style: { borderRadius: '5px 5px 0 0' } }, ((_a = groupedSubscription.bundleInfo) === null || _a === void 0 ? void 0 : _a.name) ? "".concat((_b = groupedSubscription.bundleInfo) === null || _b === void 0 ? void 0 : _b.name, "'s ").concat(bundleType, " Bundle") : "".concat(bundleType, " Bundle #").concat(subscription.id)),
            (function () {
                return (React.createElement("div", { className: 'padding-5' },
                    React.createElement("div", { className: 'font-lighter text-gray' },
                        React.createElement("div", null,
                            "Frequency: Every ",
                            subscription.order_interval_frequency,
                            " ",
                            subscription.order_interval_unit,
                            "s"),
                        React.createElement("div", null,
                            "Next Order Date: ",
                            (0, date_fns_1.format)((0, date_fns_1.parseISO)(subscription.next_charge_scheduled_at), 'MM/dd/yyyy')),
                        React.createElement("div", null,
                            "Shipping Address: ", address === null || address === void 0 ? void 0 :
                            address.address1)),
                    React.createElement(react_router_dom_1.Link, { to: "/subscriptions/edit-items/".concat(subscription.id) },
                        React.createElement("div", { className: 'padding-top-5' },
                            React.createElement("button", { className: 'padding-5 width-100 link-wisteria bg-white bordered border-wisteria' }, "Edit Bundle")))));
            })())));
});
